export default {
  products: 'products',
  productsNumber: 'Products number',
  mainImage: 'main image',
  name: 'name',
  images: 'images',
  price: 'price',
  quantity: 'quantity',
  date: 'date',
  status: 'status',
  control: 'controls',
  addProduct: ' add product',
  mainInfo: ' main information',
  productDetails: 'product details',
  transportation: ' transportation',
  productAttributes: 'product attributes',
  addAttributes: 'add new attributes',
  productRelated: ' products related',
  mainQuestions: 'common questions for products',
  addQuestions: 'add question',
  searchWords: 'search words',
  savePublish: 'save and publish',
  save: 'save',
  publish: 'publish',
  categories: {
    title: 'Categories',
    chooseCategory: 'choose category',
  },
  branches: {
    title: 'Branches',
    chooseBranches: 'choose branches',
  },
  groups: 'groups',
  taxes: 'taxes',
  chooseUnit: 'choose unit',
  unit: 'unit'
};
